module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_17.e4386178.jpeg";